import { useEffect } from "react";

/**
 * Starts the page at the top whenever `key` changes (pass the route param, e.g. the id).
 *
 * React Router keeps the previous scroll position on navigation, and in this app the page can
 * scroll in two places depending on its height: the window, or the layout's antd `<Content>`
 * (`overflow: auto` in components/Layout/Layout.tsx). Reset both.
 */
export default function useScrollToTop(key?: unknown) {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
    document.querySelectorAll<HTMLElement>(".ant-layout-content").forEach((el) => {
      el.scrollTop = 0;
    });
  }, [key]);
}
